<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Model'|translate }}
            </v-card-title>
            <v-card-text>
                <v-card-title class="accent white--text subheading">
                    {{ 'Target Equipment'|translate }}
                </v-card-title>
                <v-text-field :label="'Facility Name'|translate" v-model="activeItem.facility_name"
                              disabled></v-text-field>
                <equipment-selector v-model="activeItem.equipment_name"></equipment-selector>
                <v-divider></v-divider>
                <v-card-title class="accent white--text subheading">{{ 'Model Selection'|translate }}</v-card-title>
                <v-combobox v-model="activeItem.model_type" :items="['anomaly', 'supervised', 'power','cooling load']"
                          :label="'Model Type'|translate">
                </v-combobox>
                <v-combobox v-model="activeItem.model_name" :items="availableModelName"
                          :label="'Model Name'|translate"></v-combobox>

                <v-checkbox :label="'Active'|translate" v-model="activeItem.model_active"></v-checkbox>
                <v-text-field :label="'Topic'|translate" v-model="activeItem.topic"></v-text-field>
                <template v-if="activeItem.model_type=='supervised'">
                    <v-card-title class="accent white--text subheading">
                        {{ 'Model Message'|translate }}
                    </v-card-title>
                    <code class="pa-4">
                        {{ activeItem.result_meta }}
                    </code>
                    <v-text-field :label="'Title'|translate" v-model="activeItem.title"></v-text-field>
                    <v-text-field :label="'Description'|translate" v-model="activeItem.desc"></v-text-field>
                    <v-text-field :label="'Severity'|translate" v-model="activeItem.severity"></v-text-field>
                    <v-text-field :label="'Relevant Variables'|translate"
                                  v-model="activeItem.relevant_variables"></v-text-field>
                    <v-text-field :label="'Recommended Actions'|translate"
                                  v-model="activeItem.recommended_actions"></v-text-field>
                </template>
                <v-card-title class="accent white--text subheading">{{ 'Training Data Date Range'|translate }}</v-card-title>
                <v-layout row>
                    <date-range-selector v-model="dateRange"></date-range-selector>
                    <v-icon class="ml-2" v-if="dateRange&&dateRange.start" @click="dateRange=null">fa-times-circle</v-icon>
                </v-layout>
                <v-card-title class="accent white--text subheading">{{ 'Meta'|translate }}</v-card-title>
                <editor v-model="activeItem.model_meta" @init="editorInit" lang="json" theme="twilight" width="100%" height="500"></editor>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'Points')">
                    {{ 'Save'|translate }}
                </v-btn>
                <v-btn @click="initializeVar();dialog=false">{{ 'Cancel'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EquipmentSelector from '../EquipmentSelector'
import {putModel} from '../../helper'
import DateRangeSelector from '../DateRangeSelector'
import editor from 'vue2-ace-editor'

export default {
    components: {DateRangeSelector, EquipmentSelector, editor},
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    computed: {
        availableModelName() {
            if (this.activeItem.model_type == 'supervised') {
                if (this.$store.getters.chillerType == 'generic water-cooled') {
                    return [
                        'Reduced Condenser Water Flow',
                        'Condenser Fouling',
                        'Non-Condensable in Refrigerant',
                        'High Oil Temperature'
                    ]
                } else if (this.$store.getters.chillerType == 'air-cooled 2 circuits') {
                    return [
                        'Air Cooled Winding Temp High Ckt2',
                        'Air Cooled Winding Temp High Ckt1',
                        'Air Cooled Condenser Cleaning Required',
                        'Air Cooled Non Condensable in Refrigerant Ckt1',
                        'Air Cooled Non Condensable in Refrigerant Ckt2'
                    ]
                }
            } else if (this.activeItem.model_type == 'anomaly') {
                return ['anomaly']
            } else if (this.activeItem.model_type == 'power') {
                return ['regression', 'gradient boosted trees', 'neural network']
            } else if (this.activeItem.model_type == 'cooling load') {
                return ['boosted tree regression']
            } else {
                return []
            }
        },
    },
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                let itemdata=JSON.parse(JSON.stringify(item))
                if(itemdata.model_meta&&typeof(itemdata.model_meta)!=="string"){
                    itemdata.model_meta=JSON.stringify(itemdata.model_meta)
                }
                this.activeItem = itemdata
                if (this.activeItem.model_date_from&&this.activeItem.model_date_from!==""&&this.activeItem.model_date_from!=="NaT"){
                    this.dateRange = {
                        start: this.activeItem.model_date_from,
                        end: this.activeItem.model_date_to
                    }
                } else {
                    this.dateRange = null
                }

            }
        },
        value() {
            if (!this.activeItem.model_id&&!this.activeItem.model_type) {
                this.initializeVar()
            }
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dateRange: null,
            dialog: false,
            activeItem: {
                'model_id': null,
                'model_type': '',
                'model_name': '',
                'model_status': 'pending',
                'model_active': false,
                'title': '',
                'topic': 'default',
                'desc': '',
                'severity': '',
                'relevant_variables': '',
                'recommended_actions': '',
                'on': true,
                'equipment_name': '',
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'date_range': null,
                'model_meta': '',
            },

        }

    },
    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        initializeVar() {
            this.activeItem = {
                'model_id': null,
                'model_type': '',
                'model_name': '',
                'model_status': 'pending',
                'model_active': false,
                'title': '',
                'desc': '',
                'topic': 'default',
                'severity': '',
                'relevant_variables': '',
                'recommended_actions': '',
                'on': true,
                'equipment_name': '',
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'model_date_from': null,
                'model_date_to': null,
                'model_meta': '',
            }
        },
        async addRecord() {
            await putModel(
                {
                    'model_id': this.activeItem.model_id,
                    'model_type': this.activeItem.model_type,
                    'model_name': this.activeItem.model_name,
                    'model_status': this.activeItem.model_status,
                    'model_active': this.activeItem.model_active,
                    'title': this.activeItem.title,
                    'topic': this.activeItem.topic,
                    'desc': this.activeItem.desc,
                    'severity': this.activeItem.severity,
                    'relevant_variables': this.activeItem.relevant_variables,
                    'recommended_actions': this.activeItem.recommended_actions,
                    'on': this.activeItem.on,
                    'equipment_name': this.activeItem.equipment_name,
                    'facility_name': this.activeItem.facility_name,
                    'model_date_from': this.dateRange&&this.dateRange.start ? this.dateRange.start : null,
                    'model_date_to': this.dateRange&&this.dateRange.end ? this.dateRange.end : null,
                    'model_meta': this.activeItem.model_meta&&this.activeItem.model_meta!=="" ? JSON.parse(this.activeItem.model_meta) : null,
                }
            )
            this.$emit('doreload')
            this.dialog=false
        }
    },
    name: 'ModelRecordDialog'
}
</script>

<style scoped>

</style>
